export default {
  authorization: false,
  users: [],
  userRoles: [],
  referrals: [],
  notifications: [],
  avatarImg: "",
  logo: "",
  metrics: {
    loading: true,
    isError: false,
    data: []
  }
}
